import axios from 'axios';

async function createNewDashboardForListing(
  identifier: string,
  externalId: string,
  listingId: string,
) {
  const { data } = await axios.request<{
    retsId?: string;
    dashboardId?: string;
  }>({
    url: `/external/${identifier}/${externalId}/listing/${listingId}`,
    method: 'get',
  });

  return data.retsId || data.dashboardId;
}

export default createNewDashboardForListing;
